<div class="searchBar-container">
  <div class="searchBox-container">
      <div class="searchBox">
        <input type="text" [placeholder]="'Search by ' + searchPlaceholder" (keydown.enter)="onSearchClick()" (input)="onSearchChange($event)" [value]="searchText" >
         <img *ngIf="searchText" class="clear-icon" src="assets/images/close.svg" alt="Clear" (click)="clearSearch()" />
        <!-- <img (click)="openSearchDropdown()" class="menu-arrow" [class.rotated]="isSearchDropdownOpen" src="assets/images/menu-down-dark.svg" alt="Dropdown" > -->
      </div>
      <button [class.highlighted]="isValidSearch()" [disabled]="!isValidSearch()" (click)="onSearchClick()"><img class="magnifying" src="assets/images/magnify.svg" alt="Search"></button>
  </div>
  <div class="dropdown-container" *ngIf="isSearchDropdownOpen" style="width: 242px;" >
    <ul>
      <li *ngFor="let option of options" (click)="selectedSearchOption(option)" [class.selected]="option === selectedOption">
        {{ option }}
      </li>
    </ul>
  </div>
</div>